import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (idPost, idMessage) {
  const config = useRuntimeConfig();
  const routeLang = useRouteLang();

  try {
    return await $fetch(`${config.public.appBaseUrl}${API_ENDPOINTS.CATALOGUE_POST_ID_MESSAGE_ID_TRANSLATION}`.replace('{idPost}', idPost).replace('{idMessage}', idMessage), {
      method: 'GET',
      path: { idPost, idMessage },
      params: {
        locale: routeLang.locale.value
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
